import React, { useMemo } from 'react';
import { format, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export default function RecentTicketItem({ ticket, isActive, onSelect }) {
  const closedLabel = useMemo(() => {
    if (!ticket.closed_at) return '';
    try {
      return format(parseISO(ticket.closed_at), "dd/MM HH':'mm", {
        locale: ptBR,
      });
    } catch (e) {
      return '';
    }
  }, [ticket.closed_at]);

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => onSelect(ticket)}
      style={{
        padding: '8px 10px',
        borderRadius: '8px',
        border: isActive ? '0.5px solid #B4B2A9' : '0.5px solid #dee2e6',
        background: isActive ? '#f2f2f0' : '#fafafa',
        marginBottom: '4px',
        cursor: 'pointer',
        outline: 'none',
        opacity: 0.8,
      }}
    >
      <div
        className="d-flex justify-content-between align-items-center"
        style={{ marginBottom: '2px' }}
      >
        <span style={{ fontSize: '11px', fontWeight: 500, color: '#5F5E5A' }}>
          {ticket.customer_name || ticket.customer_phone || 'Cliente'}
        </span>
        <span style={{ fontSize: '9px', color: '#888780' }}>{closedLabel}</span>
      </div>

      {ticket.order_number && (
        <div
          style={{ fontSize: '10px', color: '#888780', marginBottom: '2px' }}
        >
          Pedido #{ticket.order_number}
        </div>
      )}

      <div className="d-flex align-items-center" style={{ gap: '4px' }}>
        <span
          style={{
            fontSize: '9px',
            color: '#888780',
            background: '#f2f2f0',
            padding: '1px 6px',
            borderRadius: '8px',
          }}
        >
          Encerrado
        </span>
        {ticket.store_name && (
          <span
            style={{
              fontSize: '9px',
              color: '#888780',
              background: '#f2f2f0',
              padding: '1px 6px',
              borderRadius: '8px',
            }}
          >
            {ticket.store_name}
          </span>
        )}
      </div>
    </div>
  );
}
